
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppComponent} from '../app.component';
import { Router } from '@angular/router';
export interface Section {
  hdID: string;
  MainDescr: string;
}
@Component({
    selector: 'app-system-configuration',
    templateUrl: './system-configuration.component.html',
    styleUrls: ['./system-configuration.component.css'],
    standalone: false
})
export class SystemConfigurationComponent implements OnInit {
  masters: any;
  master: any;
  url: string;
  modalURL: string;
  ModelFor: string;
  CallFunctionOnCloseModal: any;
  HideMasterDetails: string;
  id: any;
  ModalName: string;
  pageurl: string;
  RightsID: string;
  ManageMasterName: string;
  pageNumber: number;
  activeBG: any;

  constructor(private router: Router, private http: HttpClient) {this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.pageNumber = 1;
    this.RightsID = localStorage.getItem('UserRight');
    this.activeBG = 0;
    // if (this.RightsID.includes('202042001') || this.RightsID.includes('202042021') || this.RightsID.includes('202042000')) {
    //   } else {
    //     window.location.href = "module/0";
    //   }
    this.HideMasterDetails = '!isHidden';
    this.getAll();
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.id = pagehead[2];
   // this.getMaster(this.id, '');
    let element: HTMLElement;
    element = document.getElementsByClassName('modal-backdrop')[0] as HTMLElement;
    if (element != null) {
      element.remove();
    }
  }
  OpenPage(PageLink,id){
    this.modalURL=PageLink;
    this.HideMasterDetails = '';
    this.activeBG = id;

  }
  OpenModal(url, modelName, no) {
    this.modalURL =  url + '/' + this.id + '/' + no;
    if (this.ManageMasterName == "") { this.ManageMasterName = "Add General Master"; }
    this.ModelFor = "Add " + modelName + " Master";
    // this.ModelFor = "Add "+this.ManageMasterName+ " Master";
    }
  
  getAll() {
    this.http.get(this.url + 'SysData/Get_System_Configuration_Menu')
    .subscribe( (data) => {
        if (data == null) {
          data = 'No Data Found'; }
        this.masters = JSON.parse(data.toString());
        setTimeout(() => {
          this.masters.forEach(element => {
            element.Link = element.Link.substring(1);
          });
          this.OpenPage(this.masters[0].Link, 0);
        }, 500);
      }
    );
  }
  goBack() {
    window.history.back();
  }
}
